import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-menu',
  templateUrl: './landing-menu.component.html',
  styleUrls: ['./landing-menu.component.css']
})
export class LandingMenuComponent implements OnInit {  
  constructor(
    private router: Router
  ) { 
  }

  ngOnInit(): void {
  }

  openINMModule(): void {
    this.router.navigate(['landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04']); 
  }
  openMMModule(): void {
    this.router.navigate(['landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB']); 
  }
  openCRModule(): void {
    this.router.navigate(['landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511']); 
  }
}
